import { render, staticRenderFns } from "./BenchmarkTable.vue?vue&type=template&id=31da62d5&"
import script from "./BenchmarkTable.vue?vue&type=script&lang=js&"
export * from "./BenchmarkTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports